module.exports = __webpack_public_path__ + "images/marketing_site/CRM_HighPerformer_Mid-Market_Americas_HighPerformer.svg";